module.exports = __webpack_public_path__ + "static/media/find-provider-icon.e29b161a.svg";